import React from "react";
import { Content, IBox, Title } from "../inspinia";

class UrlCampanhaSms extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        value: '',
        onChange: () => {
            // Função anônima
        }
    }

    render() {
        return (
            <IBox className="mb-0 text-center">
                <Title>
                    <h3 className="mb-2">Insira a URL</h3>
                    <small className="form-text text-muted">A URL será inserida no fim da mensagem</small>
                </Title>

                <Content className="border-0 p-1">
                    <input type='text' className="form-control" onChange={this.props.onChange} value={this.props.value}></input>
                </Content>
            </IBox>
        );
    }
}

export default UrlCampanhaSms;